import * as tslib_1 from "tslib";
import { UiForm } from './../ui';
import { NodeForm } from './../node';
import { TextView } from './text-view';
import { TextModel } from './text-model';
var TextForm = (function (_super) {
    tslib_1.__extends(TextForm, _super);
    function TextForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TextForm.prototype, "tag", {
        get: function () {
            return 'text';
        },
        enumerable: true,
        configurable: true
    });
    TextForm.prototype.castView = function (value, stack, factory) {
        var header = value.header(this.tag);
        if (header.isDefined()) {
            var view = TextView.create();
            var modelDef = this.materializeView(view, value, stack, factory);
            view.setModel(modelDef);
            return view;
        }
        return undefined;
    };
    TextForm.prototype.castModel = function (value, stack, factory) {
        var header = value.header(this.tag);
        if (header.isDefined()) {
            var model = new TextModel();
            var dataDef = this.materializeModel(model, value, stack, factory);
            model.setData(dataDef);
            return model;
        }
        return undefined;
    };
    TextForm.Form = new TextForm();
    return TextForm;
}(NodeForm));
export { TextForm };
UiForm.addGlobal(TextForm.Form);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dC1mb3JtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGV4dC1mb3JtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQSxPQUFPLEVBQUMsTUFBTSxFQUFDLE1BQU0sU0FBUyxDQUFDO0FBQy9CLE9BQU8sRUFBQyxRQUFRLEVBQUMsTUFBTSxXQUFXLENBQUM7QUFDbkMsT0FBTyxFQUFDLFFBQVEsRUFBQyxNQUFNLGFBQWEsQ0FBQztBQUNyQyxPQUFPLEVBQUMsU0FBUyxFQUFDLE1BQU0sY0FBYyxDQUFDO0FBRXZDO0lBQThCLG9DQUE2QjtJQUEzRDs7SUE0QkEsQ0FBQztJQTNCQyxzQkFBSSx5QkFBRzthQUFQO1lBQ0UsTUFBTSxDQUFDLE1BQU0sQ0FBQztRQUNoQixDQUFDOzs7T0FBQTtJQUVELDJCQUFRLEdBQVIsVUFBUyxLQUFZLEVBQUUsS0FBZ0IsRUFBRSxPQUFlO1FBQ3RELElBQU0sTUFBTSxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ3RDLEVBQUUsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxTQUFTLEVBQUUsQ0FBQyxDQUFDLENBQUM7WUFDdkIsSUFBTSxJQUFJLEdBQUcsUUFBUSxDQUFDLE1BQU0sRUFBRSxDQUFDO1lBQy9CLElBQU0sUUFBUSxHQUFHLElBQUksQ0FBQyxlQUFlLENBQUMsSUFBSSxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsT0FBTyxDQUFDLENBQUM7WUFDbkUsSUFBSSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUMsQ0FBQztZQUN4QixNQUFNLENBQUMsSUFBSSxDQUFDO1FBQ2QsQ0FBQztRQUNELE1BQU0sQ0FBQyxTQUFTLENBQUM7SUFDbkIsQ0FBQztJQUVELDRCQUFTLEdBQVQsVUFBVSxLQUFZLEVBQUUsS0FBZ0IsRUFBRSxPQUFlO1FBQ3ZELElBQU0sTUFBTSxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDO1FBQ3RDLEVBQUUsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxTQUFTLEVBQUUsQ0FBQyxDQUFDLENBQUM7WUFDdkIsSUFBTSxLQUFLLEdBQUcsSUFBSSxTQUFTLEVBQUUsQ0FBQztZQUM5QixJQUFNLE9BQU8sR0FBRyxJQUFJLENBQUMsZ0JBQWdCLENBQUMsS0FBSyxFQUFFLEtBQUssRUFBRSxLQUFLLEVBQUUsT0FBTyxDQUFDLENBQUM7WUFDcEUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsQ0FBQztZQUN2QixNQUFNLENBQUMsS0FBSyxDQUFDO1FBQ2YsQ0FBQztRQUNELE1BQU0sQ0FBQyxTQUFTLENBQUM7SUFDbkIsQ0FBQztJQUVlLGFBQUksR0FBRyxJQUFJLFFBQVEsRUFBRSxDQUFDO0lBQ3hDLGVBQUM7Q0FBQSxBQTVCRCxDQUE4QixRQUFRLEdBNEJyQztTQTVCWSxRQUFRO0FBNkJyQixNQUFNLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQyJ9